import {
	DoughnutController as BaseDoughnutController,
} from 'chart.js';
import { each } from 'chart.js/helpers';

export default class DoughnutController extends BaseDoughnutController {
	draw() {
		const { chart } = this;
		const { ctx } = chart;
		const arcs = this.getMeta().data;
		const minCircumference = 0.06;

		each(arcs, (arc, i) => {
			arc.draw(ctx);

			/**
			 * Get the previous visible arc
			 *
			 * We use a minCircumference to keep the rounded path
			 * until the hide animation has ended.
			 */
			let prevI = i === 0 ? arcs.length - 1 : i - 1;
			while (arcs[prevI].circumference < minCircumference
				&& chart.getDataVisibility(prevI) === false
				&& prevI !== i
			) {
				prevI = prevI === 0 ? arcs.length - 1 : prevI - 1;
			}

			const prevArc = arcs[prevI];
			const prevColor = prevArc.options.backgroundColor;

			const vm = arc.options;
			const radius = (arc.outerRadius + arc.innerRadius) / 2;
			const thickness = (arc.outerRadius - arc.innerRadius) / 2;
			const startAngle = Math.PI - arc.startAngle - Math.PI / 2;
			const endAngle = Math.PI - arc.endAngle - Math.PI / 2;

			ctx.save();
			ctx.translate(arc.x, arc.y);

			if (chart.getDataVisibility(prevI) || prevArc.circumference > minCircumference) {
				ctx.fillStyle = i === 0 ? vm.backgroundColor : prevColor;
				ctx.beginPath();
				ctx.arc(
					radius * Math.sin(startAngle), radius * Math.cos(startAngle),
					thickness, 0, 2 * Math.PI,
				);
				ctx.fill();
			}

			if (chart.getDataVisibility(i) || arc.circumference > minCircumference) {
				ctx.fillStyle = vm.backgroundColor;
				ctx.beginPath();
				ctx.arc(
					radius * Math.sin(endAngle), radius * Math.cos(endAngle),
					thickness, 0, 2 * Math.PI,
				);
				ctx.fill();
			}

			ctx.restore();
		});
	}
}
